export function errMessage(e: unknown): string {
  return (
    (e as { response?: { message?: string } })?.response?.message ??
    (e as { message?: string })?.message ??
    String(e)
  );
}
